import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor() {}

  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading = this.loadingSubject.asObservable();

  private routeSubject = new BehaviorSubject<string | ''>('');
  currentRoute = this.routeSubject.asObservable();

  private paramSubject = new BehaviorSubject<boolean | false>(false);
  loginStatus = this.paramSubject.asObservable();

  checkLogin(){
    const auth = sessionStorage.getItem('auth');
    let expiry : number=0;
    if (auth) expiry = (JSON.parse(atob(auth.split('.')[1]))).exp;
    const isExpired: boolean = (Math.floor((new Date).getTime() / 1000)) >= expiry;
    const user = sessionStorage.getItem('user');
    if ((!isExpired && user)) {
      this.paramSubject.next(true);
      return true;
    } else {
      this.paramSubject.next(false);
      return false;
    }
  }
  
  LoadingOn() {
    this.loadingSubject.next(true);
  }
  LoadingOff() {
    this.loadingSubject.next(false);
  }
  setRoute(route: string = '') {
    this.routeSubject.next(route);
  }




  //#region Toast Components

  time: number = Date.now();
  success: boolean = true;
  toastTitle: string = 'Place Holder Title';
  toastContent: string = 'Place Holder Content';
  Toast(success: boolean, title: string, content: string = "") {
    this.success = success;
    this.toastTitle = title;
    this.toastContent = content;
    const time = new Date();

    const toastContainer = document.getElementById('toast-container');

    // Create a toast element
    const toast = document.createElement('div');
    toast.className = this.success
      ? 'toast show text-bg-success'
      : 'toast show text-bg-danger';
    toast.innerHTML = content == '' ?
    `<div class="d-flex"><div class="toast-body text-light">
            <span class="rounded-4 me-2" style="width: 10px;height: 10px;"></span>
            <strong class="me-auto ">${this.toastTitle}</strong>
            <small>${time.toLocaleTimeString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })}</small>
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>`
      :
      `<div class="toast-header">
            <span class="rounded-4 me-2" style="width: 10px;height: 10px;"></span>
            <strong class="me-auto">${this.toastTitle}</strong>
            <small>${time.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })}</small>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
          <div class="toast-body text-light"">
            ${this.toastContent}
          </div>`;
    if (!toastContainer) {
      console.error('Toast container not found!');
      return; // Exit the function if the container is not found
    }
    // Append the toast to the container
    toastContainer.appendChild(toast);

    new (window as any).bootstrap.Toast(toast, { delay: 10000 }).show();

    toast.addEventListener('hidden.bs.toast', function () {
      toast.remove();
    });
  }
  //#endregion
}
